import { useEffect } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import {
  chatbotUsageAsyncAtom,
  interfacesUsageAsyncAtom,
  numberOfUniqueTableNodesAtom,
  numberOfUniqueInterfaceNodesAtom,
  numberOfUniqueChatbotNodesAtom,
  tablesUsageAsyncAtom,
} from "@zapier/canvas-state";

export function useTabFocus() {
  const numberOfTableNodes = useAtomValue(numberOfUniqueTableNodesAtom);
  const numberOfInterfaceNodes = useAtomValue(numberOfUniqueInterfaceNodesAtom);
  const numberOfChatbotNodes = useAtomValue(numberOfUniqueChatbotNodesAtom);

  const refreshTablesUsage = useSetAtom(tablesUsageAsyncAtom);
  const refreshInterfacesUsage = useSetAtom(interfacesUsageAsyncAtom);
  const refreshChatbotsUsage = useSetAtom(chatbotUsageAsyncAtom);

  useEffect(() => {
    const handleFocus = () => {
      if (numberOfTableNodes > 0) {
        refreshTablesUsage();
      }

      if (numberOfInterfaceNodes > 0) {
        refreshInterfacesUsage();
      }

      if (numberOfChatbotNodes > 0) {
        refreshChatbotsUsage();
      }
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [
    numberOfTableNodes,
    numberOfInterfaceNodes,
    numberOfChatbotNodes,
    refreshTablesUsage,
    refreshInterfacesUsage,
    refreshChatbotsUsage,
  ]);
}
